export default __webpack_public_path__ + "static/media/chevron_left_white.92307ff4.svg";